import React from "react";
import { CircularProgress } from '@mui/material';
import ReactDOM from 'react-dom';

const modalRoot = document.getElementById('modal-root')

export default class Loader extends React.Component<any, any> {
    el: HTMLElement

    constructor(props: any) {
        super(props)
        this.el = document.createElement('div')
    }

    componentDidMount() {

        if (modalRoot) {
            modalRoot.appendChild(this.el)
        }
    }

    componentWillUnmount() {
        if (modalRoot) {
            modalRoot.removeChild(this.el)
        }
    }

    public render() {
        let transparentDiv = {
            opacity: 0.6,
            'willChange': 'opacity',
            transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            position: 'fixed' as 'fixed',
            zIndex: 1250
        }

        return ReactDOM.createPortal(<div>
            <div aria-hidden="true" style={transparentDiv}></div>
            <CircularProgress size={48} className='buttonProgress' /></div>, this.el)
    }
}